import expediter from './expediter'
import priceType from './priceType'

export default {
  expediter: expediter,
  priceType: priceType
}



// WEBPACK FOOTER //
// ./src/storage/index.js